import { UserRole } from '@modules/core/types';
import { Permissions } from '@modules/permissions/types';

export const WAKEMED_PRODUCTION = {
  [UserRole.ADMINISTRATOR]: [
    Permissions.GENETIC_COUNSELING,
    Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
    Permissions.CDC_TIER1_METRICS,
    Permissions.CAMPAIGN_TRACKING,
    Permissions.CAN_VIEW_PHI,
  ],
  [UserRole.EXECUTIVE]: [
    Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
    Permissions.CDC_TIER1_METRICS,
    Permissions.CAMPAIGN_TRACKING,
  ],
  [UserRole.MEMBER_LIMITED_PHI]: [
    Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
    Permissions.CDC_TIER1_METRICS,
    Permissions.CAMPAIGN_TRACKING,
  ],
  [UserRole.MEMBER]: [
    Permissions.GENETIC_COUNSELING,
    Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
    Permissions.CDC_TIER1_METRICS,
    Permissions.CAMPAIGN_TRACKING,
    Permissions.CAN_VIEW_PHI,
  ],
};
